export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const meta = {
  alias: 'pricing-table',
  name: 'Pricing Table'
} as const;
